/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuctionDto } from '../models/AuctionDto';
import type { AuctionModel } from '../models/AuctionModel';
import type { BranchRequirementsModel } from '../models/BranchRequirementsModel';
import type { BranchType } from '../models/BranchType';
import type { FuelType } from '../models/FuelType';
import type { GradeEnum } from '../models/GradeEnum';
import type { NoteCommonSaveModel } from '../models/NoteCommonSaveModel';
import type { PurchasePlannarPreferableFiltersModel } from '../models/PurchasePlannarPreferableFiltersModel';
import type { PurchasePlannerDetailsDto } from '../models/PurchasePlannerDetailsDto';
import type { PurchasePlannerDto } from '../models/PurchasePlannerDto';
import type { PurchasePlannerDtoPagedListData } from '../models/PurchasePlannerDtoPagedListData';
import type { PurchasePlannerVehicle } from '../models/PurchasePlannerVehicle';
import type { ServiceCheckSubmitModel } from '../models/ServiceCheckSubmitModel';
import type { TransmissionType } from '../models/TransmissionType';
import type { UpdatePurchaseDesireModel } from '../models/UpdatePurchaseDesireModel';
import type { UpdatePurchaseDetailsModel } from '../models/UpdatePurchaseDetailsModel';
import type { UpdatePurchaseModel } from '../models/UpdatePurchaseModel';
import type { UpdatePurchaseValuationsAndMetricsModel } from '../models/UpdatePurchaseValuationsAndMetricsModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PurchasePlannerService {

  /**
   * @param date 
   * @param isPurchased 
   * @param transmission
 *
 * 0 = Undefined
 *
 * 1 = ManualOld (Code "M")
 *
 * 2 = Speed4
 *
 * 3 = Speed5
 *
 * 4 = Speed6
 *
 * 5 = Automatic
 *
 * 6 = Cvt (CVT Continuously Variable Transmission)
 *
 * 7 = SemiAtomatic
 *
 * 8 = Manual (Code "MANUAL")
 *
 * 16 = Auto
   * @param fuelType
 *
 * 0 = Undefined
 *
 * 1 = Star2 (2-Star)
 *
 * 2 = BiFuelGas (Bi-fuel Gas)
 *
 * 3 = BiFuelPetrol (Bi-fuel Petrol)
 *
 * 4 = Diesel
 *
 * 5 = ElectricOnly (Electric only)
 *
 * 6 = Hybrid
 *
 * 7 = Lpg
 *
 * 8 = Mixed
 *
 * 9 = Other
 *
 * 10 = Petrol
 *
 * 11 = Unleaded
   * @param grade
 *
 * 0 = Grade0
 *
 * 1 = Grade1
 *
 * 2 = Grade2
 *
 * 3 = Grade3
 *
 * 4 = Grade4
 *
 * 5 = Grade5
 *
 * 6 = Grade6
 *
 * 7 = Grade7
 *
 * 8 = Grade8
 *
 * 9 = Grade9
 *
 * 10 = Grade10
 *
 * 11 = Grade11
 *
 * 12 = Grade12
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param requiredForBranch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param auction 
   * @param isParsed 
   * @param tier 
   * @param model 
   * @param regNo 
   * @param isPreferable 
   * @param isDesirable 
   * @param userAuthorised 
   * @param preferableSettingsRatingFrom 
   * @param preferableSettingsRatingTo 
   * @param preferableSettingsDaysToSellFrom 
   * @param preferableSettingsDaysToSellTo 
   * @param preferableSettingsOwnersFrom 
   * @param preferableSettingsOwnersTo 
   * @param preferableSettingsMileageFrom 
   * @param preferableSettingsMileageTo 
   * @param preferableSettingsGradeFrom 
   * @param preferableSettingsGradeTo 
   * @param preferableSettingsUserUpdated 
   * @param preferableSettingsUserUpdatedId 
   * @param preferableSettingsDateUpdated 
   * @param skipPagination Пропустить пагинацию
   * @param page Страница
   * @param maxCount Максимально количество записей на странице
   * @returns PurchasePlannerDtoPagedListData Success
   * @throws ApiError
   */
  public static getPurchasePlannerGetPurchasePlannerData(
date?: string,
isPurchased?: boolean,
transmission?: TransmissionType,
fuelType?: FuelType,
grade?: GradeEnum,
branch?: BranchType,
requiredForBranch?: BranchType,
auction?: number,
isParsed?: boolean,
tier?: number,
model?: Array<string>,
regNo?: string,
isPreferable?: boolean,
isDesirable?: boolean,
userAuthorised?: number,
preferableSettingsRatingFrom?: number,
preferableSettingsRatingTo?: number,
preferableSettingsDaysToSellFrom?: number,
preferableSettingsDaysToSellTo?: number,
preferableSettingsOwnersFrom?: number,
preferableSettingsOwnersTo?: number,
preferableSettingsMileageFrom?: number,
preferableSettingsMileageTo?: number,
preferableSettingsGradeFrom?: number,
preferableSettingsGradeTo?: number,
preferableSettingsUserUpdated?: string,
preferableSettingsUserUpdatedId?: number,
preferableSettingsDateUpdated?: string,
skipPagination?: boolean,
page?: number,
maxCount?: number,
): CancelablePromise<PurchasePlannerDtoPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/purchase-planner/get-purchase-planner-data',
      query: {
        'Date': date,
        'IsPurchased': isPurchased,
        'Transmission': transmission,
        'FuelType': fuelType,
        'Grade': grade,
        'Branch': branch,
        'RequiredForBranch': requiredForBranch,
        'Auction': auction,
        'IsParsed': isParsed,
        'Tier': tier,
        'Model': model,
        'RegNo': regNo,
        'IsPreferable': isPreferable,
        'IsDesirable': isDesirable,
        'UserAuthorised': userAuthorised,
        'PreferableSettings.RatingFrom': preferableSettingsRatingFrom,
        'PreferableSettings.RatingTo': preferableSettingsRatingTo,
        'PreferableSettings.DaysToSellFrom': preferableSettingsDaysToSellFrom,
        'PreferableSettings.DaysToSellTo': preferableSettingsDaysToSellTo,
        'PreferableSettings.OwnersFrom': preferableSettingsOwnersFrom,
        'PreferableSettings.OwnersTo': preferableSettingsOwnersTo,
        'PreferableSettings.MileageFrom': preferableSettingsMileageFrom,
        'PreferableSettings.MileageTo': preferableSettingsMileageTo,
        'PreferableSettings.GradeFrom': preferableSettingsGradeFrom,
        'PreferableSettings.GradeTo': preferableSettingsGradeTo,
        'PreferableSettings.UserUpdated': preferableSettingsUserUpdated,
        'PreferableSettings.UserUpdatedId': preferableSettingsUserUpdatedId,
        'PreferableSettings.DateUpdated': preferableSettingsDateUpdated,
        'SkipPagination': skipPagination,
        'Page': page,
        'MaxCount': maxCount,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param day 
   * @returns string Success
   * @throws ApiError
   */
  public static getPurchasePlannerGetPurchasePlannerModels(
day?: string,
): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/purchase-planner/get-purchase-planner-models',
      query: {
        'day': day,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns PurchasePlannerDetailsDto Success
   * @throws ApiError
   */
  public static getPurchasePlannerGetPurchasePlannerDetailsData(
id: number,
): CancelablePromise<PurchasePlannerDetailsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/purchase-planner/get-purchase-planner-details-data/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putPurchasePlannerUpdatePurchasePlannerDetailsData(
requestBody?: UpdatePurchaseDetailsModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/purchase-planner/update-purchase-planner-details-data',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static patchPurchasePlannerUpdatePurchasePlannerValuationsAndMetrics(
requestBody?: UpdatePurchaseValuationsAndMetricsModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/purchase-planner/update-purchase-planner-valuations-and-metrics',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putPurchasePlannerUpdatePurchase(
requestBody?: UpdatePurchaseModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/purchase-planner/update-purchase',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postPurchasePlannerAddPurchasePlannerData(
requestBody?: PurchasePlannerVehicle,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/purchase-planner/add-purchase-planner-data',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putPurchasePlannerUpdateDesirableAndBranch(
requestBody?: UpdatePurchaseDesireModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/purchase-planner/update-desirable-and-branch',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns AuctionDto Success
   * @throws ApiError
   */
  public static getPurchasePlannerGetAuctions(): CancelablePromise<Array<AuctionDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/purchase-planner/get-auctions',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postPurchasePlannerAddNewAuction(
requestBody?: AuctionModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/purchase-planner/add-new-auction',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putPurchasePlannerUpdateAuction(
requestBody?: AuctionModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/purchase-planner/update-auction',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static deletePurchasePlannerDeleteAuction(
id: number,
requestBody?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/purchase-planner/delete-auction/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static deletePurchasePlannerDeletePurchase(
id: number,
requestBody?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/purchase-planner/delete-purchase/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param model 
   * @returns BranchRequirementsModel Success
   * @throws ApiError
   */
  public static getPurchasePlannerBranchRequirements(
model?: string,
): CancelablePromise<Array<BranchRequirementsModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/purchase-planner/branch-requirements',
      query: {
        'model': model,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param purchasePlannerId 
   * @returns PurchasePlannerDto Success
   * @throws ApiError
   */
  public static getPurchasePlannerGetNotes(
purchasePlannerId?: number,
): CancelablePromise<Array<PurchasePlannerDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/purchase-planner/get-notes',
      query: {
        'PurchasePlannerId': purchasePlannerId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postPurchasePlannerAddNewNote(
requestBody?: NoteCommonSaveModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/purchase-planner/add-new-note',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @param userId 
   * @param formData 
   * @returns any Created
   * @throws ApiError
   */
  public static postPurchasePlannerUploadFile(
id: number,
userId: number,
formData?: {
file: Blob;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/purchase-planner/upload-file/{id}',
      path: {
        'id': id,
      },
      query: {
        'userId': userId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @returns string Success
   * @throws ApiError
   */
  public static getPurchasePlannerExportMfld(): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/purchase-planner/export-mfld',
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postPurchasePlannerSaveServiceCheck(
requestBody?: ServiceCheckSubmitModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/purchase-planner/save-service-check',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param dateFrom 
   * @param dateTo 
   * @returns string Success
   * @throws ApiError
   */
  public static getPurchasePlannerExportPeriodCsv(
dateFrom?: string,
dateTo?: string,
): CancelablePromise<string> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/purchase-planner/export-period-csv',
      query: {
        'dateFrom': dateFrom,
        'dateTo': dateTo,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static postPurchasePlannerSavePreferableSettings(
requestBody?: PurchasePlannarPreferableFiltersModel,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/purchase-planner/save-preferable-settings',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns PurchasePlannarPreferableFiltersModel Success
   * @throws ApiError
   */
  public static getPurchasePlannerGetPreferableSettings(): CancelablePromise<PurchasePlannarPreferableFiltersModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/purchase-planner/get-preferable-settings',
      errors: {
        400: `Bad Request`,
      },
    });
  }

}
